import { ColDef } from 'ag-grid-community';
import { ExcelStyle } from 'ag-grid-community';

export const csrDay7ColDefs: ColDef[] = [
  {
    wrapText: true,
    autoHeight: true,
    field: 'checkbox',
    headerName: '',
    headerTooltip: '',
    width: 50,
    checkboxSelection: true,
    headerCheckboxSelection: true,
  },
  {
    field: 'plateNumber',
    headerName: 'Plate #',
    width: 35,
  },
  { field: 'embryoId', headerName: 'Embryo ID', width: 80, editable: true },
  { field: 'account', headerName: 'Account', width: 60, editable: true },
  { field: 'breed', headerName: 'Brd', width: 30, editable: true },
  { field: 'bullBreed', headerName: 'Bull Brd', width: 50, editable: true },
  { field: 'donor', headerName: 'Donor', width: 80, editable: true },
  { field: 'sire', headerName: 'Sire', width: 100, editable: true },
  { field: 'st', headerName: 'ST', width: 40, editable: true },
  {
    field: 'transferPlan',
    headerName: 'Transfer Plan',
    width: 70,
    editable: true,
  },
  {
    field: 'implantType',
    headerName: 'Implant Type',
    width: 120,
    editable: (params) => !params.context.isUpdateRunning,

    autoHeight: true,
    wrapText: true,
    cellEditor: 'agRichSelectCellEditor',
    cellEditorParams: {
      values: [
        'Weaned Calf',
        'Live Calf',
        'Purchased Pregnancy',
        'Client Recip - TOG Transfer',
        'Clone',
        'Research',
        'Training',
        'GAP',
        'Non-TOG Implant',
      ],
    },
  },
  { field: 'recipFrame', headerName: 'Recip Frame', width: 40, editable: true },
  { field: 'export', headerName: 'Export', width: 40, editable: true },
  { field: 'embTag', headerName: 'Emb Tag', width: 40, editable: true },
  { field: 'stage', headerName: 'Stg', width: 30, editable: true },
  {
    field: 'grade',
    headerName: 'Grd',
    width: 30,
    editable: true,
    cellClassRules: {
      'bg-tog-pink': (params) => params.value === 3,
    },
  },
  {
    field: 'freshStrawNo',
    headerName: 'Fresh Straw No',
    width: 60,
    editable: true,
  },
  {
    field: 'embryoToBe',
    headerName: 'Embryo to be?',
    width: 120,
    editable: (params) =>
      !params.data.embryoToBe?.includes('6.5') &&
      !params.context.isUpdateRunning,
    cellEditor: 'agRichSelectCellEditor',
    cellEditorParams: {
      values: ['Frozen', 'Implanted', 'Discarded'],
    },

    cellClassRules: {
      'bg-tog-pink': (params) => params.value === 'Implanted',
      'bg-tog-yellow': (params) => params.value === 'Frozen',
    },
  },
  { field: 'hldFrz', headerName: 'HLD-FRZ', width: 40, editable: true },
  { field: 'hldTrf', headerName: 'HLD-TRF', width: 40, editable: true },
  {
    field: 'hldFrzTrfLg',
    headerName: 'HLD-FRZ/TRF LG',
    width: 40,
    editable: true,
  },
  { field: 'togRecip', headerName: 'TOG Recip', width: 40, editable: true },
  {
    field: 'clientRecip',
    headerName: 'Client Recip',
    width: 40,
    editable: true,
  },
  {
    field: 'csrComments',
    headerName: 'CSR Comments',
    width: 190,
    editable: true,
    autoHeight: true,
    wrapText: true,
    cellClassRules: {
      'bg-tog-yellow': (params) =>
        params.value !== null && params.value !== '' && params.value !== ' ',
    },
  },
  {
    field: 'donorOwners',
    headerName: 'Donor Owner(s)',
    width: 80,
    editable: true,
  },
];

export const csrDay7SummaryColDefs: ColDef[] = [
  {
    field: 'account',
    headerName: 'Account',
    width: 120,
    cellStyle: (params) => {
      if (params.data.isHeader) {
        return {
          fontWeight: 'bold',
          backgroundColor: '#f0f0f0',
          paddingLeft: '',
        };
      }
      return {
        fontWeight: '',
        backgroundColor: '',
        paddingLeft: '20px',
      };
    },
    rowDrag: true,
  },
  {
    field: 'mating',
    headerName: 'Mating',
    width: 120,
    valueGetter: (params) => (params.data.isHeader ? '' : params.data.mating),
  },
  {
    field: 'sire',
    headerName: 'Sire',
    width: 120,
    valueGetter: (params) => (params.data.isHeader ? '' : params.data.sire),
  },
  {
    field: 'breed',
    headerName: 'Sire Breed',
    width: 120,
    valueGetter: (params) => (params.data.isHeader ? '' : params.data.breed),
  },
  {
    field: 'bullBreed',
    headerName: 'Bull Breed',
    width: 100,
    valueGetter: (params) =>
      params.data.isHeader ? '' : params.data.bullBreed,
  },
  {
    field: 'frozen',
    headerName: 'Frozen',
    width: 100,
  },
  {
    field: 'implanted',
    headerName: 'Implanted',
    width: 100,
  },
  {
    field: 'd65Frozen',
    headerName: 'D6.5-Froz',
    width: 100,
  },
  {
    field: 'discarded',
    headerName: 'Discarded',
    width: 100,
  },
  {
    field: 'total',
    headerName: 'Total',
    width: 100,
  },
];

export const csrDay7RecipSummaryColDefs: ColDef[] = [
  {
    field: 'recipFrame',
    headerName: 'Recip',
    width: 80,
    rowDrag: true,
  },
  {
    field: 'breed',
    headerName: 'Donor Breed',
    width: 100,
  },
  {
    field: 'bullBreed',
    headerName: 'Sire Breed',
    width: 100,
  },
  {
    field: 'st',
    headerName: 'Semen Type',
    width: 100,
  },
  {
    field: 'count',
    headerName: 'Count',
    width: 80,
    type: 'numericColumn',
  },
];

export const excelStyles: ExcelStyle[] = [
  {
    id: 'cell',
    alignment: {
      vertical: 'Center',
    },
    borders: {
      borderBottom: {
        color: '#000000',
        lineStyle: 'Continuous',
        weight: 1,
      },
      borderTop: {
        color: '#000000',
        lineStyle: 'Continuous',
        weight: 1,
      },
      borderLeft: {
        color: '#000000',
        lineStyle: 'Continuous',
        weight: 1,
      },
      borderRight: {
        color: '#000000',
        lineStyle: 'Continuous',
        weight: 1,
      },
    },
  },

  {
    id: 'bg-tog-light-purple',
    interior: {
      color: '#E6E6FA',
      pattern: 'Solid',
    },
  },
  {
    id: 'bg-tog-light-green',
    interior: {
      color: '#90EE90',
      pattern: 'Solid',
    },
  },
  {
    id: 'bg-tog-pink',
    interior: {
      color: '#f7b6c0',
      pattern: 'Solid',
    },
  },
  {
    id: 'bg-tog-yellow',
    interior: {
      color: '#ffff00',
      pattern: 'Solid',
    },
  },
  {
    id: 'darkGreyBackground',
    interior: {
      color: '#888888',
      pattern: 'Solid',
    },
    font: {
      fontName: 'Calibri Light',
      color: '#ffffff',
    },
  },
];
